import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserNotificationAlert } from '../../interfaces';
import { UserNotificationsService } from '../../service/noty/user-notification.service';
import { NOTI_HEADER } from '../../constants/user-notification';

@Injectable({
  providedIn: 'root',
})
export class UserNotificationInterceptor implements HttpInterceptor {
  constructor(private readonly notyStickyService: UserNotificationsService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((res: HttpResponse<any>) => {
        if (!res.headers) {
          return;
        }
        const headerValues = res.headers.getAll(NOTI_HEADER);
        const notiDataHeader = headerValues && headerValues.length > 0 ? headerValues[0] : null;
        if (!notiDataHeader) {
          return;
        }
        const notiData: UserNotificationAlert = JSON.parse(decodeURIComponent(notiDataHeader));
        this.notyStickyService.updateUserNotification(notiData);
      }),
    );
  }
}
